module.exports = __webpack_public_path__ + "assets/5-Bullion_spec_hero.0d2718b0.svg";